import { ActionType } from "../types";
import { Flag, FlagsAction } from "../types/flags";

export function toggleFlag(name: Flag, value?: boolean): FlagsAction {
  return {
    type: ActionType.TOGGLE_FLAG,
    name,
    value,
  };
}
